export class MagicStructureResponseData {
    public numMemberships: number;

    public fulfilledMembershipCount: number;
    public unfulfilledMembershipCount: number;
}
